<div class="px-4 text-xs">
  <slot />
</div>
